import React, { useEffect } from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider
} from "react-router-dom";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import PasswordReset from "./pages/PasswordReset";
import theme from "./theme";

let route: string = window.location.href.split("/")[3];

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/password-reset" element={<ForgotPassword />} />
      <Route path={route} element={<Register />} />
      <Route path="/credential/:token" element={<PasswordReset />} />
      <Route path="*" element={<Register />} />
    </Route>
  )
);

function App() {
  useEffect(() => {
    if (route === "#") {
      window.location.href = "/password-reset";
    }
    if (!route) {
      route = "/register";
    }
  }, []);
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </div>
  );
}

export default App;
